import { render } from "./CustomWalletButton.vue?vue&type=template&id=6ebaae8e"
import script from "./CustomWalletButton.vue?vue&type=script&lang=js"
export * from "./CustomWalletButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bewinxed/Downloads/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__